import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { UserService } from 'src/app/services/user/user.service';
import { mobiscroll, MbscDatetimeOptions, MbscFormOptions } from '@mobiscroll/angular';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import * as alertifyjs from 'alertifyjs';
import { MathUtils } from '../../utils/math-utils';
import { AuthService } from 'src/app/services/auth/auth.service';

mobiscroll.settings = {
  lang: 'es',
  theme: 'ios',
  themeVariant: 'light',
};

const now = new Date();

//const week = [ new Date(now.getFullYear(),0, 1),now];
let week = [new Date(), new Date()];

@Component({
  selector: 'app-rates',
  templateUrl: './rates.component.html',
  styleUrls: ['./rates.component.css'],
  providers: [DatePipe]
})
export class RatesComponent implements OnInit {

  loading: any;
  rates: any = [];
  submit_disabled: any;
  errorMsg: any;

  // ✅ Nuevas propiedades para manejo de múltiples fuentes
  activeTab: string = 'MT'; // Pestaña activa por defecto

  // Definición de fuentes de tasas disponibles
  rateSources = [
    { code: 'MT', name: 'MT (Principal)', chanel: ['CREDIT_API-historyRateExchangeApi', 'CREDIT_API-updateBCVRate'] },
    { code: 'SEGUROS_MERCANTIL', name: 'Mercantil Seguros', chanel: ['SEGUROS_MERCANTIL'] },
    { code: 'SEGUROS_CARACAS', name: 'Seguros Caracas', chanel: ['SEGUROS_CARACAS'] },
    // Plan 33: Venemergencia expone tasa BCV via endpoint dinamico del proveedor,
    // no captura manual. Persistencia diaria en External_rate con este chanel.
    { code: 'VE', name: 'Venemergencia (TuDoc)', chanel: ['SERVICIOS_VENEMERGENCIAS'] }
  ];

  // Plan 33: estado del tab Venemergencia.
  tudocLivePrices: any = null;                 // {price_usd_raw, tasa_bcv, multiplier, price_usd_final, price_bs_final, snapshot_at}
  tudocLiveError: string | null = null;        // 'PRICES_UNAVAILABLE' | 'KILL_SWITCH_ACTIVE' | 'PRODUCT_DISABLED' | ...
  tudocLiveLoading = false;
  tudocProduct: any = null;                    // Insurance_product TUDOC completo (para leer/editar multiplier)
  tudocProductError: string | null = null;
  tudocMultiplierInput: number = 2;
  tudocMultiplierSaving = false;
  readonly TUDOC_MULTIPLIER_MIN = 1;
  readonly TUDOC_MULTIPLIER_MAX = 10;
  readonly TUDOC_MULTIPLIER_STEP = 0.1;

  // ✅ Propiedades para formulario de tasas externas
  formExternal: any;
  submit_disabled_external: any;
  date_base_external: any = new Date();
  date_base_string_external: any;

  range: Array<Date> = week;
  date: Array<Date> = [];
  nonForm: Array<Date> = [];
  external = week;
  d1: any;
  d2: any;
  form: any;

  showClientRate: any = null;
  showMsRate: any = null;
  showScRate: any = null;
  toggleLoading: any = false;
  roundAmount: any;

  dateSetting3: MbscDatetimeOptions = {
    lang: 'es',
    theme: 'ios',
    themeVariant: 'light',
    responsive: {
      small: {
        controls: ['calendar'],
        display: 'center'
      },
      medium: {
        display: 'bubble',
      }
    }

  };

  birthday = new Date();
  date_base: any = new Date;
  date_base_string: any;

  mobileSettings: MbscDatetimeOptions = {
    display: 'bottom',
    themeVariant: 'dark',
  };


  desktopSettings: MbscDatetimeOptions = {
    display: 'bubble',
    touchUi: false
  };


  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    public socketService: SocketioService,
    private offcanvasService: NgbOffcanvas,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    public _auth: AuthService

  ) { }

  ngOnInit(): void {
    this.date_base_string = this.datePipe.transform(this.date_base, 'MM/dd/yyyy');
    this.date_base_string_external = this.datePipe.transform(this.date_base_external, 'MM/dd/yyyy');


    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    this.getHistoryRates();
    this.loadShowClientRate();
    this.loadShowMsRate();
    this.loadShowScRate();

    // Formulario para tasas MT
    this.form = this.formBuilder.group({
      amount: ['', [Validators.required]],
      type: ['BS', [Validators.required]],
    });

    // ✅ Formulario para tasas externas
    this.formExternal = this.formBuilder.group({
      amount: ['', [Validators.required]],
      type: ['BS', [Validators.required]],
    });

  }





  getHistoryRates = async () => {
    try {
      this.loading = true;

      // ✅ Si es MT, solo consultar el sistema base (no external_rates)
      if (this.activeTab === 'MT') {
        const respMT = await this.getHistoryRatesServer();
        this.rates = respMT?.res || [];
      } else {
        // ✅ Para otras fuentes (SEGUROS_MERCANTIL, etc.), solo consultar external_rates
        const respExternal = await this.getExternalRatesServer();
        this.rates = respExternal?.data || [];
      }

    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  }

  getHistoryRatesServer = async () => {
    try {
      let query = {
        init: this.d1,
        end: this.d2
      }
      return this._user.getHistoryRates(query);
    } catch (error) {
      console.error(error);
      return { res: [] };
    }
  }

  // ✅ Nuevo método para consultar tasas externas por rango
  getExternalRatesServer = async () => {
    try {
      // Obtener el canal de la pestaña activa
      const activeSource = this.rateSources.find(s => s.code === this.activeTab);
      const chanel = activeSource?.chanel[0]; // Usar el primer canal del array
      
      // Consultar tasas externas en el rango de fechas seleccionado, filtradas por canal
      return this._user.getExternalRatesByRange(this.d1, this.d2, chanel);
    } catch (error) {
      console.error('Error al consultar tasas externas:', error);
      return { data: [] };
    }
  }



  birthdaySet() {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    this.getHistoryRates();

  }

  pocisionBottom = async (content: TemplateRef<any>, data: any = {}) => {

    try {

      this.offcanvasService.open(content, { position: 'bottom', keyboard: false });

    } catch (error) {
      console.log(error);

    }

  }


  submit = async () => {

    if (this.form.valid) {
      this.submit_disabled = true;
      const data = this.form.getRawValue();

      let params = {
        "subscriptor": 1,
        "type": data.type,
        date: this.date_base_string,
        amount: data.amount
      };

      try {

        let resp = await this._user.setHistoryRate(params);
        alertifyjs.success('Registro exitoso');

        location.reload();
        // this.getHistoryRates();






        this.submit_disabled = false;
        this.offcanvasService.dismiss();

        this.form = this.formBuilder.group({

          amount: ['', [Validators.required]],
          type: ['BS', [Validators.required]],

        });


      } catch (error: any) {

        const params = error?.error?.error;
        if (params?.code) {
          this.errorMsg = params?.msg;
        }

        this.submit_disabled = false;
      }
    }

  }

  dateSet(e: any) {

    let date_base = e.valueText;

    let temp = date_base ? date_base.split("/") : [];
    this.date_base_string = `${temp[1]}/${temp[0]}/${temp[2]}`;

  }


  moveCursorToEnd(event: any) {
    const input = event.target;
    input.selectionStart = input.selectionEnd = input.value.length;
  }

  toFixedApp = (x: any): string => {
    return MathUtils.toFixed2(x);
  }

  // ✅ Cambiar pestaña activa
  changeTab(tabCode: string) {
    this.activeTab = tabCode;
    this.getHistoryRates();
    // Plan 33: al entrar al tab VE, cargar en paralelo card live + producto TUDOC.
    if (tabCode === 'VE') {
      this.loadTuDocLivePrices();
      this.loadTuDocProduct();
    }
  }

  // Plan 33: consulta live de tasa vigente + precios TuDoc.
  loadTuDocLivePrices = async () => {
    this.tudocLiveLoading = true;
    this.tudocLiveError = null;
    try {
      const resp: any = await this._user.getTuDocLivePrices();
      // Backend responde {ok:true, data:{...}} en algunos endpoints o el objeto plano.
      // Ver controllers/venemergencias.js handleGetTuDocPrices para forma exacta.
      this.tudocLivePrices = resp?.data ?? resp;
    } catch (err: any) {
      const code = err?.error?.code || err?.error?.error?.code || err?.code || 'UNKNOWN';
      this.tudocLiveError = code;
      this.tudocLivePrices = null;
    } finally {
      this.tudocLiveLoading = false;
      this.cdr.detectChanges();
    }
  }

  refreshTuDocPrices = () => this.loadTuDocLivePrices();

  // Plan 33: descubre el Insurance_product TUDOC via search=TUDOC (D-13, evita
  // hardcodear _id por environment). Extrae el multiplier vigente del mapping[VE].
  loadTuDocProduct = async () => {
    this.tudocProductError = null;
    try {
      const resp: any = await this._user.getInsuranceProductBySearch('TUDOC');
      const list: any[] = resp?.data || [];
      const product = list.find(p => p?.code === 'TUDOC');
      if (!product) {
        this.tudocProduct = null;
        this.tudocProductError = 'PRODUCT_NOT_FOUND';
        return;
      }
      this.tudocProduct = product;
      const veMapping = (product.mapping || []).find((m: any) => m?.clave === 'VE');
      const current = Number(veMapping?.params?.price_multiplier);
      this.tudocMultiplierInput = Number.isFinite(current) && current > 0 ? current : 2;
    } catch (err: any) {
      this.tudocProduct = null;
      this.tudocProductError = err?.error?.code || err?.code || 'UNKNOWN';
    } finally {
      this.cdr.detectChanges();
    }
  }

  // Plan 33: guarda price_multiplier via PUT /console/products/:id.
  // Muta mapping[VE].params.price_multiplier del producto en memoria y envia el
  // mapping completo (el endpoint reemplaza el array).
  saveTuDocMultiplier = async () => {
    if (!this.tudocProduct) return;

    // Validacion de rango (D-10). Redondeo a 2 decimales (D-11).
    const raw = Number(this.tudocMultiplierInput);
    if (!Number.isFinite(raw) || raw < this.TUDOC_MULTIPLIER_MIN || raw > this.TUDOC_MULTIPLIER_MAX) {
      alertifyjs.error(`El multiplicador debe estar entre ${this.TUDOC_MULTIPLIER_MIN} y ${this.TUDOC_MULTIPLIER_MAX}`);
      return;
    }
    const rounded = Math.round(raw * 100) / 100;

    // Clonar mapping y mutar la entry VE (el helper backend lee params.price_multiplier).
    const newMapping = (this.tudocProduct.mapping || []).map((m: any) => {
      if (m?.clave !== 'VE') return m;
      return { ...m, params: { ...(m.params || {}), price_multiplier: rounded } };
    });

    this.tudocMultiplierSaving = true;
    try {
      await this._user.updateInsuranceProduct(this.tudocProduct._id, { mapping: newMapping });
      alertifyjs.success('Multiplicador actualizado');
      // Refrescar producto + card live para reflejar el nuevo precio final.
      await this.loadTuDocProduct();
      await this.loadTuDocLivePrices();
    } catch (err: any) {
      const msg = err?.error?.msg || err?.error?.error?.msg || 'Error al guardar el multiplicador';
      alertifyjs.error(msg);
    } finally {
      this.tudocMultiplierSaving = false;
      this.cdr.detectChanges();
    }
  }

  // Plan 33: helper para el disabled del boton Guardar en el html.
  isTuDocMultiplierUnchanged(): boolean {
    if (!this.tudocProduct) return true;
    const veMapping = (this.tudocProduct.mapping || []).find((m: any) => m?.clave === 'VE');
    const current = Number(veMapping?.params?.price_multiplier);
    return Number.isFinite(current) && Math.abs(current - Number(this.tudocMultiplierInput || 0)) < 0.005;
  }

  // Obtener el estado del toggle según la pestaña activa
  getCurrentToggleState(): boolean | null {
    if (this.activeTab === 'MT') {
      return this.showClientRate;
    } else if (this.activeTab === 'SEGUROS_MERCANTIL') {
      return this.showMsRate;
    }
    return null;
  }

  // ✅ Obtener nombre de la fuente activa
  getActiveSourceName(): string {
    const source = this.rateSources.find(s => s.code === this.activeTab);
    return source ? source.name : '';
  }

  // ✅ Método para configurar fecha de tasa externa
  dateSetExternal(e: any) {
    let date_base = e.valueText;
    let temp = date_base ? date_base.split("/") : [];
    this.date_base_string_external = `${temp[1]}/${temp[0]}/${temp[2]}`;
  }

  // ✅ Método para guardar tasa externa
  submitExternal = async () => {
    if (this.formExternal.valid) {
      this.submit_disabled_external = true;
      const data = this.formExternal.getRawValue();

      let params = {
        amount: data.amount,
        chanel: this.activeTab,
        date: this.date_base_string_external
      };

      try {
        let resp = await this._user.saveExternalRate(params.amount, params.chanel, params.date);

        if (resp?.success) {
          alertifyjs.success('Tasa guardada exitosamente');
          this.getHistoryRates();
          this.offcanvasService.dismiss();

          // Resetear formulario
          this.formExternal = this.formBuilder.group({
            amount: ['', [Validators.required]],
            type: ['BS', [Validators.required]],
          });
        } else {
          alertifyjs.error('Error al guardar la tasa');
        }

        this.submit_disabled_external = false;

      } catch (error: any) {
        const errorMsg = error?.error?.msg || error?.error?.error?.msg || 'Error al guardar la tasa';
        alertifyjs.error(errorMsg);
        this.submit_disabled_external = false;
      }
    }
  }

  loadShowClientRate = async () => {
    try {
      const resp = await this._user.getShowClientRate();
      console.log('Response from getShowClientRate:', resp);

      let value: any;

      // El valor viene en data.show_client_rate según el usuario
      if (resp?.data?.show_client_rate !== undefined) {
        value = resp.data.show_client_rate;
      } else if (resp?.show_client_rate !== undefined) {
        value = resp.show_client_rate;
      } else if (resp?.res?.show_client_rate !== undefined) {
        value = resp.res.show_client_rate;
      } else {
        value = false;
      }

      // Convertir a boolean explícitamente (el API puede devolver string "false" o "true")
      if (value === 'false' || value === false || value === 0 || value === '0') {
        this.showClientRate = false;
      } else if (value === 'true' || value === true || value === 1 || value === '1') {
        this.showClientRate = true;
      } else {
        this.showClientRate = false;
      }

      console.log('showClientRate set to:', this.showClientRate, '(original value was:', value, ')');

      // Forzar detección de cambios para actualizar el checkbox
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading show client rate:', error);
      this.showClientRate = false;
      this.cdr.detectChanges();
    }
  }

  loadShowMsRate = async () => {
    try {
      const resp = await this._user.getShowMsRate();
      console.log('Response from getShowMsRate:', resp);

      let value: any;

      // El valor viene en data.show_ms_rate según el usuario
      if (resp?.data?.show_ms_rate !== undefined) {
        value = resp.data.show_ms_rate;
      } else if (resp?.show_ms_rate !== undefined) {
        value = resp.show_ms_rate;
      } else if (resp?.res?.show_ms_rate !== undefined) {
        value = resp.res.show_ms_rate;
      } else {
        value = false;
      }

      // Convertir a boolean explícitamente (el API puede devolver string "false" o "true")
      if (value === 'false' || value === false || value === 0 || value === '0') {
        this.showMsRate = false;
      } else if (value === 'true' || value === true || value === 1 || value === '1') {
        this.showMsRate = true;
      } else {
        this.showMsRate = false;
      }

      console.log('showMsRate set to:', this.showMsRate, '(original value was:', value, ')');

      // Forzar detección de cambios para actualizar el checkbox
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading show ms rate:', error);
      this.showMsRate = false;
      this.cdr.detectChanges();
    }
  }

  loadShowScRate = async () => {
    try {
      const resp = await this._user.getShowScRate();
      console.log('Response from getShowScRate:', resp);

      let value: any;

      // El valor viene en data.show_sc_rate según el usuario
      if (resp?.data?.show_sc_rate !== undefined) {
        value = resp.data.show_sc_rate;
      } else if (resp?.show_sc_rate !== undefined) {
        value = resp.show_sc_rate;
      } else if (resp?.res?.show_sc_rate !== undefined) {
        value = resp.res.show_sc_rate;
      } else {
        value = false;
      }

      // Convertir a boolean explícitamente (el API puede devolver string "false" o "true")
      if (value === 'false' || value === false || value === 0 || value === '0') {
        this.showScRate = false;
      } else if (value === 'true' || value === true || value === 1 || value === '1') {
        this.showScRate = true;
      } else {
        this.showScRate = false;
      }

      console.log('showScRate set to:', this.showScRate, '(original value was:', value, ')');

      // Forzar detección de cambios para actualizar el checkbox
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading show sc rate:', error);
      this.showScRate = false;
      this.cdr.detectChanges();
    }
  }

  onToggleChange = async (event: any) => {
    if (this.toggleLoading) {
      event.preventDefault();
      return;
    }

    const checkbox = event.target;
    const newValue = checkbox.checked;

    try {
      this.toggleLoading = true;

      let resp;
      if (this.activeTab === 'MT') {
        resp = await this._user.updateShowClientRate({
          show_client_rate: newValue
        });

        if (resp) {
          this.showClientRate = newValue;
          alertifyjs.success(newValue ? 'Tasa visible para clientes' : 'Tasa oculta para clientes');
        } else {
          // Revertir el checkbox si falla
          checkbox.checked = !newValue;
          this.showClientRate = !newValue;
        }
      } else if (this.activeTab === 'SEGUROS_MERCANTIL') {
        resp = await this._user.updateShowMsRate({
          show_ms_rate: newValue
        });

        if (resp) {
          this.showMsRate = newValue;
          alertifyjs.success(newValue ? 'Tasa visible para clientes' : 'Tasa oculta para clientes');
        } else {
          // Revertir el checkbox si falla
          checkbox.checked = !newValue;
          this.showMsRate = !newValue;
        }
      } else if (this.activeTab === 'SEGUROS_CARACAS') {
        resp = await this._user.updateShowScRate({
          show_sc_rate: newValue
        });

        if (resp) {
          this.showScRate = newValue;
          alertifyjs.success(newValue ? 'Tasa visible para clientes' : 'Tasa oculta para clientes');
        } else {
          // Revertir el checkbox si falla
          checkbox.checked = !newValue;
          this.showScRate = !newValue;
        }
      }
    } catch (error) {
      console.error('Error updating rate visibility:', error);
      alertifyjs.error('Error al actualizar la configuración');
      // Revertir el checkbox en caso de error
      checkbox.checked = !newValue;
      if (this.activeTab === 'MT') {
        this.showClientRate = !newValue;
      } else if (this.activeTab === 'SEGUROS_MERCANTIL') {
        this.showMsRate = !newValue;
      } else if (this.activeTab === 'SEGUROS_CARACAS') {
        this.showScRate = !newValue;
      }
    } finally {
      this.toggleLoading = false;
    }
  }

}
